import { createFileRoute } from '@tanstack/react-router'
import { ContractEditor } from '~/features/compensation/ContractEditor'
import { NoFinanceAccess } from '~/features/compensation/parts'
import { candidatesQuery, loaderSeason, typesQuery } from '~/features/compensation/queries'
import { useCan } from '~/lib/session'

const UUID = /^[0-9a-f-]{36}$/i

export const Route = createFileRoute('/_app/verein/praemien/vertraege/neu')({
  // ?person= preselects the person (hint "Spieler hat Einsätze, aber keinen Vertrag").
  validateSearch: (s: Record<string, unknown>): { person?: string } => (typeof s.person === 'string' && UUID.test(s.person) ? { person: s.person } : {}),
  loader: async ({ context }) => {
    const s = await loaderSeason(context.queryClient)
    if (s?.canRead) await Promise.all([context.queryClient.ensureQueryData(typesQuery()), context.queryClient.ensureQueryData(candidatesQuery())])
  },
  component: function NeuerVertrag() {
    const { person } = Route.useSearch()
    return useCan()('finance.write') ? <ContractEditor {...(person ? { personId: person } : {})} /> : <NoFinanceAccess title="Verträge" />
  },
})
